/*
 * @Author       : 程哲林
 * @Date         : 2024-01-09 10:22:17
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-01-25 14:20:24
 * @FilePath     : /marketing-introduce-ssr/utils/bridge.ts
 * @Description  : 未添加文件描述
 */
import JsBridge from '@woulsl-app/js-bridge';
import { Toast } from 'antd-mobile';
import Cookies from 'js-cookie';
import QS from 'querystring';

import { DEBUG, PACKAGE_NAME, UC_API_DOMAIN, WX_JOJO_PARENTS } from '../common/const';
import { isJoJoBrowser } from './index';
import { reportCustomError } from './sentry';

const isJoJoApp = isJoJoBrowser();

const bridge: any = isJoJoApp ? new JsBridge() : {};
const canUseBridge = bridge.canUseBridge ? bridge.canUseBridge() : false;

const jojoWeChatInstalled = async (): Promise<boolean> => {
  let isJJWeChatInstalled = true;
  try {
    // 该判断只在叫叫App内，且canUseBridge为真的情况下，走微信判断
    if (isJoJoApp && canUseBridge) {
      const res: {
        status: number;
        data: { isInstalled: boolean };
      } = await bridge.isWechatInstalled();

      if (res.status === 200) {
        isJJWeChatInstalled = Boolean(res.data.isInstalled);
      }
    }
  } catch (e) {
    console.error(e);
  }

  return isJJWeChatInstalled;
};

const isWxInstalled = async () => {
  let isJJWeChatInstalled = true;

  try {
    if (canUseBridge) {
      const res: {
        status: number;
        data: { isInstalled: boolean };
      } = await bridge.isWechatInstalled();

      if (res.status === 200) {
        isJJWeChatInstalled = Boolean(res.data.isInstalled);
      }
    }
  } catch (e) {
    console.error(e);
  }

  return isJJWeChatInstalled;
};

const jojoAppLogin = async (url = '') => {
  try {
    if (!isJoJoApp) {
      return 2;
    }
    if (Cookies.get('authToken')) {
      return 1;
    }
    const { status, data } = await bridge.call('nativeLogin');
    if (status === 200 && data && data?.authToken) {
      window.location.href = `${UC_API_DOMAIN}/page/appWeb/portal/appWebLogin?authToken=${
        data?.authToken
      }&packageName=mp.tinman.JoJoRead&targetUrl=${url || window.location.href}`;
    } else {
      return 0;
    }
  } catch (e) {
    console.error(e);
    return 0;
  }

  return 3;
};

type AppInfo = {
  bundleID?: string;
  appName?: string;
  version?: string;
  UUID?: string;
};

let appInfo: AppInfo = {};
export async function getAppInfo(): Promise<AppInfo> {
  if (appInfo.appName || !(isJoJoApp && canUseBridge)) {
    return appInfo;
  }

  try {
    const { status, data } = await bridge.call('appInfo');
    if (status === 200) {
      appInfo = data;
      return data;
    }
  } catch (e) {
    console.error(e);
  }

  return {};
}

// 直接登录
let loginTimer: any = null;
const jojoAppDirectLogin = (url = '', cb?: (status: number) => void) => {
  try {
    clearTimeout(loginTimer);
    loginTimer = setTimeout(async () => {
      let sta = -1;
      let packageName = PACKAGE_NAME;
      try {
        const ua = window.navigator.userAgent;
        const [{ status, data }, { bundleID }] = await Promise.all([
          bridge.call('nativeLogin'),
          getAppInfo()
        ]);

        if (/huiben/gim.test(ua)) {
          packageName = 'com.jojoread.huiben';
        } else if (bundleID) {
          packageName = bundleID;
        }

        sta = status;

        if (status === 200 && data && data.authToken) {
          window.location.href = `${UC_API_DOMAIN}/page/appWeb/portal/appWebLogin?authToken=${
            data.authToken
          }&packageName=${packageName}&targetUrl=${encodeURIComponent(
            url || window.location.href
          )}`;
        }
      } catch (e: any) {
        reportCustomError({
          name: '调用APP登陆失败',
          message: e.message || sta.toString(),
          stack: e.stack
        });
      }

      if (typeof cb === 'function') {
        cb(sta);
      }
    }, 300);
  } catch (e) {
    console.error(e);
  }
};

// 判断是否支持某个API
export async function hasAppApi(api: string) {
  try {
    if (!(isJoJoApp && canUseBridge)) {
      return false;
    }

    const { status, data } = await bridge.call('hasApi', {
      methodName: api
    });

    return status === 200 && data?.hasApi;
  } catch (e) {
    return false;
  }
}

interface IShareMiniCardParams {
  title: string;
  image: string;
  url: string;
  needLogin?: boolean;
}

/**
 * 分享家长端小程序webview卡片
 * @param {string} params.title 分享出去的标题
 * @param {string} params.image 分享卡片的图片
 * @param {string} params.url 分享的目标url
 * @param {(err:string|null,res；*)=>void} cb 回调函数
 * @description 文档地址：https://jojoread.yuque.com/luio9y/bs329f/vnzwcc
 */
export function shareH5ToParentsMiniProgram(
  params: IShareMiniCardParams,
  cb: (err: string | null, res: any) => void = () => {}
) {
  bridge.call(
    'shareMiniProgram',
    {
      title: params.title || '叫叫',
      desc: '',
      image: params.image || '',
      url: params.url || '',
      appId: WX_JOJO_PARENTS,
      path: `pages/transform_space/index?${QS.stringify({
        pageName: 'webview',
        linkUrl: params.url,
        needLogin: params.needLogin ? 1 : ''
      })}`,
      type: DEBUG ? 2 : 0
    },
    (res: any) => {
      const { status, msg } = res;
      if (status !== 200) {
        Toast.show(res.msg || '分享失败，未安装第三方平台');
        cb(msg, null);
        return;
      }
      cb(null, {});
    }
  );
}

export const saveImage = async (base64: string) => {
  try {
    const { status } = await bridge.call('saveBase64Image', {
      base64
    });

    return status === 200;
  } catch (e) {
    console.log(e);
  }

  return false;
};

export { canUseBridge, isWxInstalled, jojoAppDirectLogin, jojoAppLogin, jojoWeChatInstalled };

export default bridge;
